module.exports = __webpack_public_path__ + "img/icon-market-blue.f159679c.svg";